import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { SURVEY_META } from "../lib/survey-config";
import { isValidParticipant, sanitizeParticipant } from "../lib/participant";

export function Welcome() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const initial = params.get("p") ?? "";
  const [name, setName] = useState(sanitizeParticipant(initial));

  function start(e?: React.FormEvent) {
    e?.preventDefault();
    const clean = sanitizeParticipant(name);
    if (!isValidParticipant(clean)) return;
    navigate(`/survey?p=${encodeURIComponent(clean)}`);
  }

  const cleanPreview = sanitizeParticipant(name);
  const valid = isValidParticipant(cleanPreview);

  return (
    <div className="flex flex-1 flex-col justify-center gap-10">
      <header className="space-y-3">
        <p className="text-sm font-medium text-accent">Workshop-Onboarding</p>
        <h1 className="text-3xl font-semibold tracking-tight md:text-4xl">
          {SURVEY_META.title}
        </h1>
        <p className="text-fg-muted leading-relaxed">{SURVEY_META.intro}</p>
      </header>

      <form onSubmit={start} className="space-y-3">
        <label htmlFor="participant" className="block text-sm font-medium">
          Wer bist du?
        </label>
        <input
          id="participant"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="anna oder ben"
          autoComplete="off"
          autoFocus={!initial}
          spellCheck={false}
          className="w-full rounded-input border border-border bg-bg-elevated px-4 py-3 text-base outline-none transition focus:border-accent"
        />
        <p className="text-xs text-fg-muted">
          {name && cleanPreview !== name
            ? `Wird gespeichert als: ${cleanPreview || "(leer)"}`
            : "Kleinbuchstaben, Zahlen, Bindestrich oder Unterstrich."}
        </p>

        <button
          type="submit"
          disabled={!valid}
          className="mt-2 inline-flex items-center gap-2 rounded-input bg-accent px-5 py-3 text-sm font-medium text-accent-fg transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-30"
        >
          Los geht's →
        </button>
      </form>

      <p className="border-t border-border pt-6 text-sm text-fg-muted">
        Du willst sehen, was in den nächsten 8 Wochen passiert?{" "}
        <Link
          to="/timeline"
          className="text-accent underline underline-offset-2 hover:opacity-80"
        >
          Schau dir die Timeline an →
        </Link>
      </p>
    </div>
  );
}
